import React from 'react';
import '../styles/App.css';

const formatLive = (value) => (Number.isFinite(value) ? String(value) : '\u2013');

const StatsSection = ({ stats, live }) => {
  return (
    <div className="stats-section">
      <div className={`stats-grid${live ? ' stats-grid-live' : ''}`}>
        <div className="stat-item">
          <div className="stat-label">Total Calls</div>
          <div className="stat-value">{stats.total_calls || 0}</div>
        </div>
        <div className="stat-item">
          <div className="stat-label">Completed</div>
          <div className="stat-value stat-success">{stats.completed_calls || 0}</div>
        </div>
        <div className="stat-item">
          <div className="stat-label">Failed</div>
          <div className="stat-value stat-danger">{stats.failed_calls || 0}</div>
        </div>
        <div className="stat-item">
          <div className="stat-label">Success Rate</div>
          <div className="stat-value">{stats.success_rate || 0}%</div>
        </div>
        {live && (
          <>
            <div className="stat-item stat-item-live">
              <div className="stat-label">
                <span className="live-dot" aria-hidden="true" />
                Outgoing Calls (Live)
              </div>
              <div
                className="stat-value stat-live"
                data-testid="live-outgoing"
                title={live.partial ? 'Some servers did not answer, this may be lower than the real number.' : undefined}
              >
                {formatLive(live.available ? live.outgoing : null)}
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-label">
                <span className="live-dot" aria-hidden="true" />
                Incoming Calls (Live)
              </div>
              <div
                className="stat-value stat-live"
                data-testid="live-incoming"
                title={live.partial ? 'Some servers did not answer, this may be lower than the real number.' : undefined}
              >
                {formatLive(live.available ? live.incoming : null)}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default StatsSection;
